import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Chat from './components/Chat';  // Import the Chat component
import RegisterForm from './components/auth/RegisterForm';
import LoginForm from './components/auth/LoginForm';
import appStyles from './App.module.css';
import WelcomePage from './pages/WelcomePage';
import CheckoutReturn from './pages/CheckoutReturn';
import SuccessPage from './pages/SuccessPage';
import './components/auth/LoginRegister.css';
import styles from './App.module.css';
console.log("👀 App.js mounted");
import { Navigate } from 'react-router-dom';
import { useChat } from './context/ChatContext';
import TestChatInput from './pages/TestChatInput';
import SplashPage from './pages/SplashPage';
import AboutPage from './pages/InfoPages/AboutPage';
import HelpPage from './pages/InfoPages/HelpPage';
import PrivacyPage from './pages/InfoPages/PrivacyPage';
import FounderPage from './pages/InfoPages/FounderMessage';
import TermsPage from './pages/InfoPages/TermsPage';
import ContactPage from './pages/InfoPages/ContactPage';
import BurgerMenu from './components/layout/BurgerMenu';
import FaqPage from './pages/InfoPages/FaqPage';  // adjust path if needed
import ResetPassword from './components/auth/ResetPassword';
import ResetConfirm from './components/auth/ResetConfirm';
import Home from './pages/mind-mesch/Home';
import About from './pages/mind-mesch/About';
import Faq from './pages/mind-mesch/Faq';
import Help from './pages/mind-mesch/Help';
import Privacy from './pages/mind-mesch/Privacy';
import Terms from './pages/mind-mesch/Terms';
import PartnerApi from './pages/mind-mesch/PartnerAPI';
import PartnerDocs from './pages/mind-mesch/Docs';
import DocsViewer from './pages/DocsViewer';


const ProtectedRoute = ({ children }) => {
  const { user, loading } = useChat();

  console.log('🛡️ ProtectedRoute:', { user, loading });

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    console.log('🚫 No user, redirecting to /login');
    return <Navigate to="/login" replace />;
  }

  console.log('✅ User found, rendering protected route');
  return children;
};

const LOGIN_REQUIRED = true; // Change to true to require login

const App = () => {
    const [theme, setTheme] = useState('light');

    const toggleTheme = () => {
        setTheme(theme === 'light' ? 'dark' : 'light');
    };

const themeStyles = {
        light: {
            backgroundColor: '#f9f9f9',
            color: '#000',
            headerColor: '#0084ff',
        },
        dark: {
            backgroundColor: '#333',
            color: '#fff',
            headerColor: '#ffffff',
        },
    };

const currentTheme = themeStyles[theme];

    return (
<Router>
<div className={`${appStyles.container} ${theme === 'dark' ? appStyles.darkBackground : appStyles.lightBackground}`}>
<div className={appStyles.headerBar}>
  <div className={appStyles.headerContent}>
    <div className={appStyles.headerLeft}>
      
      <BurgerMenu />

    </div>

  <h1 className={styles.headerTitle}>
    <span className={styles['daisy-dark']}>d</span>
    <span className={styles['daisy-highlight']}>AI</span>
    <span className={styles['daisy-dark']}>sy</span>
  </h1>
    <div className={appStyles.themeToggle}>
      <button onClick={toggleTheme}>
        {theme === 'dark' ? '🌞' : '🌙'}
      </button>
    </div>
  </div>
</div>

<Routes>
  {/* 🔐 Protected */}
  <Route
    path="/chat"
    element={
      <ProtectedRoute>
        <Chat theme={theme} />
      </ProtectedRoute>
    }
  />



  {/* 🛠 Test */}
  <Route path="/test-chat-input" element={<TestChatInput />} />

  {/* 🏠 Splash page is now the public home */}
  <Route path="/" element={<SplashPage theme={theme} />} />

  {/* 🔑 Auth */}
  <Route path="/login" element={<LoginForm />} />
  <Route path="/register" element={<RegisterForm />} />
  <Route path="/reset-password" element={<ResetPassword />} />
  <Route path="/reset-confirm" element={<ResetConfirm />} />

  {/* 📄 Info pages */}
  <Route path="/about" element={<AboutPage theme={theme} />} />
<Route path="/help" element={<HelpPage theme={theme} />} />
<Route path="/privacy" element={<PrivacyPage theme={theme} />} />
<Route path="/founder" element={<FounderPage theme={theme} />} />
<Route path="/terms" element={<TermsPage theme={theme} />} />
<Route path="/contact" element={<ContactPage theme={theme} />} />
<Route path="/faq" element={<FaqPage theme={theme} />} />
<Route path="/docs" element={<DocsViewer />} />

  {/* 🌐 Mind Mesch Pages */}
  <Route path="/mind-mesch" element={<Home />} />
  <Route path="/mind-mesch/about" element={<About />} />
  <Route path="/mind-mesch/faq" element={<Faq />} />
  <Route path="/mind-mesch/help" element={<Help />} />
  <Route path="/mind-mesch/privacy" element={<Privacy />} />
  <Route path="/mind-mesch/terms" element={<Terms />} />
  <Route path="/mind-mesch/partner-api" element={<PartnerApi />} />
  <Route path="/mind-mesch/docs" element={<PartnerDocs />} />

  {/* 💳 Stripe */}
  <Route path="/welcome" element={<WelcomePage />} />
  <Route path="/checkout-return" element={<CheckoutReturn />} />
  <Route path="/success" element={<SuccessPage />} />
</Routes>


<p className={appStyles.watermark}>Your AI Chat Pal</p>
</div> {/* container div for theme */}
</Router>
);
};

export default App;

